import { render, staticRenderFns } from "./MaterialPropertyModal.vue?vue&type=template&id=b046930a&scoped=true"
import script from "./MaterialPropertyModal.vue?vue&type=script&lang=js"
export * from "./MaterialPropertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b046930a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b046930a')) {
      api.createRecord('b046930a', component.options)
    } else {
      api.reload('b046930a', component.options)
    }
    module.hot.accept("./MaterialPropertyModal.vue?vue&type=template&id=b046930a&scoped=true", function () {
      api.rerender('b046930a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/MaterialPropertyModal.vue"
export default component.exports